import React from "react";
import * as c from "./lcSearchResults.module.scss";
import { Highlight, Snippet, useInstantSearch, useHits } from "react-instantsearch";
import { Link } from "gatsby";

const Results = ({ children }) => {
  const { results, status } = useInstantSearch({ catchError: true });

  if (status === "error") {
    return <div className={c.noResults}>Search is temporarily unavailable.</div>;
  }

  if (results?.nbHits > 0) {
    return children;
  }

  return <div className={c.noResults}>No results for '{results?.query}'</div>;
};

const Hits = ({ hits }) => {
  return (
    <ol className={c.hits}>
      {hits.map((hit) => (
        <li className={c.hit} key={hit.objectID}>
          <Link className={c.link} to={hit.path}>
            <Highlight className={c.title} hit={hit} attribute="title" highlightedTagName="em" />
            <div className={c.breadcrumbs}>
              {hit.type === "FAQ" && hit.articleTitle ? hit.articleTitle : hit.breadcrumbs}
            </div>
            <Snippet className={c.body} hit={hit} attribute="body" highlightedTagName="em" />
          </Link>
        </li>
      ))}
    </ol>
  );
};

export default function LcSearchResults({ isSearchFocused }) {
  // Register hits before the first query so Algolia uses the expected highlight tags.
  const { items } = useHits();
  const { results } = useInstantSearch({ catchError: true });
  const hasQuery = results?.query?.length > 0;
  const shouldRender = isSearchFocused && hasQuery;

  if (!shouldRender) return null;

  return (
    <div className={c.container} tabIndex="0">
      <Results>
        <Hits hits={items} />
      </Results>
    </div>
  );
}
